// extracted by mini-css-extract-plugin
module.exports = {"facePileMore":"ValueFacePile_facePileMore__2cTYa","wrapper":"ValueFacePile_wrapper__2tjDO"};